import React from 'react';
import ReactChipInput from "react-chip-input";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import { CONTACT_NEED_APPROVE_FIELDS, CONTACT_SEARCH_FIELDS } from "@app/constants/Common";


const ContactsImportantCard = ({
    isEditContacts,
    setIsEditContacts,
    updateCandidateContacts,
    contacts,
    userLoginInfo,
    checkEmailToSendInErrorBlockEmail,
    haveEmailToSendAdNotInAllEmailToSends,
    checkEmailToSendInAllEmail,
    onAddContactItem,
    onRemoveContactItem,
    inputDisableView,
    allInputInfo,
    mode = 'Edit', // Default to Edit mode for backward compatibility
    isEditImportantContacts = false
}) => {

    let searchFields = CONTACT_SEARCH_FIELDS;
    if (mode === 'Edit') {
        searchFields = CONTACT_NEED_APPROVE_FIELDS;
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Contacts quan trọng</h3>
                {mode === 'Edit' && (
                    <div className='card-tools'>
                        {(isEditContacts || isEditImportantContacts) &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEditContacts(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {(isEditContacts || isEditImportantContacts) &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateCandidateContacts(true);
                                    }}
                            >
                                Save
                            </button>
                        }
                        {!(isEditContacts || isEditImportantContacts) &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditContacts(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                )}
            </div>
            <div className='card-body pt-0'>
                {searchFields.map((field, i) => {
                    let fieldValue = contacts[field.key] ? contacts[field.key] : []
                    if (field.key === 'email_to_send_ad' && !userLoginInfo.is_superuser) {
                        return ""
                    }

                    if (mode === 'Search' && (field.key === 'email' || field.key === 'phone')) {
                        return ""
                    }
                    return <div className='input-group mt-3' key={`contact_need_${field.key}`}>
                        <label className={'w-100'}>{field.label}</label>
                        {field.key === 'email_to_send' &&
                            checkEmailToSendInErrorBlockEmail()
                        }
                        {field.key === 'email_to_send_ad' &&
                            haveEmailToSendAdNotInAllEmailToSends(fieldValue, allInputInfo.allContactsInfo)
                        }
                        {field.key === 'email_to_send' &&
                            checkEmailToSendInAllEmail()
                        }
                        {mode === 'Edit' &&
                        <>
                            <ReactChipInput
                                classes="class1 class2 w-100"
                                chips={fieldValue}
                                onSubmit={value => onAddContactItem(value, field.key)}
                                onRemove={index => onRemoveContactItem(index, field.key)}
                            />
                            {!(isEditContacts || isEditImportantContacts) && inputDisableView(fieldValue, i)}
                            <AllUserInputField arrInfo={allInputInfo.allContactsInfo}
                                            field={field.key}/>
                        </>
                        }


                        {mode === 'Search' &&
                        <>
                            <input type='text' className='form-control' placeholder={field.label} value={fieldValue} onChange={e => onAddContactItem(e.target.value, field.key)}/>
                        </>
                        }
                    </div>
                })}
            </div>
        </div>
    );
};

export default ContactsImportantCard;


